import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

const variantStyles = {
  primary: 'bg-primary hover:bg-primary-container text-on-primary shadow-xl shadow-primary/20',
  secondary: 'bg-surface-container-high hover:bg-surface-container-highest text-primary',
  white: 'bg-white hover:bg-slate-50 text-primary shadow-sm',
  outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-on-primary',
};

const baseStyles =
  'inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 font-headline font-bold text-lg transition-all active:scale-95';

interface LandingButtonProps {
  variant?: keyof typeof variantStyles;
  children: ReactNode;
  className?: string;
  to?: string;
  href?: string;
}

export function LandingButton({
  variant = 'primary',
  children,
  className = '',
  to,
  href,
}: LandingButtonProps) {
  const cls = `${baseStyles} ${variantStyles[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={cls}>
        {children}
      </Link>
    );
  }

  return (
    <a href={href} className={cls}>
      {children}
    </a>
  );
}
